import { errorGQLHandler } from '@/helpers/helpers';
import NOTICIA_DESTAQUE from '../../../graphql/revista/queries/NoticiaDestaque.gql';
import BUSCAR_ACESSO_RAPIDO from '../../../graphql/revista/queries/BuscarAcessoRapido.gql';
import ACESSO_VISOES_CANAIS from '../../../graphql/revista/queries/acessoVisaoCanais.gql';
import NOTICIAS_SE_LIGA from '../../../graphql/revista/queries/NoticiasSeLiga.gql';
import env from '@/config/env';

const DESTAQUES = 'DESTAQUES';
const SET_NOTICIA_ACESSO_RAPIDO = 'SET_NOTICIA_ACESSO_RAPIDO';

const IMPULSIONE_VENDAS_NOTICIAS = 'IMPULSIONE_VENDAS_NOTICIAS';
const SET_CARREGANDO_IMPULSIONE_VENDAS = 'SET_CARREGANDO_IMPULSIONE_VENDAS';

export const NEXT_PAGE_NOTICIA_ACESSO_RAPIDO = 'NEXT_PAGE_NOTICIA_ACESSO_RAPIDO';
export const PREV_PAGE_NOTICIA_ACESSO_RAPIDO = 'PREV_PAGE_NOTICIA_ACESSO_RAPIDO';

const FIRST_PAGE_NOTICIA_ACESSO_RAPIDO = 'FIRST_PAGE_NOTICIA_ACESSO_RAPIDO';
const SET_LAST__PAGE_NOTICIA_ACESSO_RAPIDO = 'SET_LAST__PAGE_NOTICIA_ACESSO_RAPIDO';
const LAST_PAGE_NOTICIA_ACESSO_RAPIDO = 'LAST_PAGE_NOTICIA_ACESSO_RAPIDO';
const SET_CARREGANDO = 'SET_CARREGANDO';
const SET_CANAL = 'SET_CANAL';
const ACESSO_CANAIS = 'ACESSO_CANAIS';


export default {
  namespaced: true,
  state: {
    perPage: 12,
    carregando: false,
    data: [],
    impulsioneVendasNoticias: [], 
    noticiaAcessoRapido: [],
    pageAcessoRapido: 1,
    latPageAcessoRapido: 0,
    canal: null,
    acessoCanais: {}
  },
  getters: {
    destaques: state => state.data,
    carregando: state => state.carregando,
    impulsioneVendasNoticias: state => state.impulsioneVendasNoticias,
    carregandoImpulsioneVendas: state => state.carregandoImpulsioneVendas,
    getNoticiasAcessoRapido: state => state.noticiaAcessoRapido,
    getPerPage: state => state.perPage,
    canal: state => state.canal || window.localStorage.getItem('canalSimulado') ,
    acessoCanais: state => state.acessoCanais,
  },
  mutations: {
    [DESTAQUES](state, payload) {
      state.carregando = false;
      state.data = payload;
    },
    [IMPULSIONE_VENDAS_NOTICIAS](state, payload) { 
      state.carregandoImpulsioneVendas = false;
      state.impulsioneVendasNoticias = payload;
    },
    [SET_CARREGANDO_IMPULSIONE_VENDAS](state, payload) { 
      state.carregandoImpulsioneVendas = payload;
    },
    [SET_NOTICIA_ACESSO_RAPIDO](state, payload) {
      state.noticiaAcessoRapido = payload;
    },
    [NEXT_PAGE_NOTICIA_ACESSO_RAPIDO](state) {
      state.pageAcessoRapido = state.pageAcessoRapido + 1;
    },
    [PREV_PAGE_NOTICIA_ACESSO_RAPIDO](state) {
      state.pageAcessoRapido = state.pageAcessoRapido - 1;
    },
    [FIRST_PAGE_NOTICIA_ACESSO_RAPIDO](state) {
      state.pageAcessoRapido = 1;
    },
    [SET_LAST__PAGE_NOTICIA_ACESSO_RAPIDO](state, payload) {
      state.latPageAcessoRapido = payload;
    },
    [LAST_PAGE_NOTICIA_ACESSO_RAPIDO](state) {
      state.pageAcessoRapido = state.latPageAcessoRapido;
    },
    [SET_CARREGANDO](state, payload) {
      state.carregando = payload;
    },
    [SET_CANAL](state, payload) {
      window.localStorage.setItem('canalSimulado', payload);
      state.canal = payload;
    },
    [ACESSO_CANAIS](state, payload) {
      state.acessoCanais = payload;
    },
  },
  actions: {
    getHomePageNoticias({ commit, state, rootGetters }, limit) {
      const perPage = limit || state.perPage;
      state.carregando = true;
      state.data = [];

      setTimeout(async () => {
        const uf = rootGetters['user/uf'];
        if (uf) {
          env.apolloRevista
            .query({
              query: NOTICIA_DESTAQUE,
              variables: {
                modulo: env.revista.modulo,
                canal: rootGetters['home/canal'],
                destaque: 1,
                paginate: perPage,
                uf: [uf],
              },
              fetchPolicy: 'no-cache',
            })
            .then(
              ({ data: { noticias } }) => {
                commit(DESTAQUES, noticias.data);
              },
              err => errorGQLHandler(err),
            );
        }
      });
    },
    getHomeImpulsioneVendasNoticias({ commit, state, rootGetters }) {   
      commit(SET_CARREGANDO_IMPULSIONE_VENDAS, true);
      state.impulsioneVendasNoticias = [];

      setTimeout(async () => {
        const uf = rootGetters['user/uf'];
        if (uf) {
          try {
            const { data: { noticias } } = await env.apolloRevista.query({
              query: NOTICIAS_SE_LIGA,
              variables: {
                modulo: env.revista.modulo,
                canal: rootGetters['home/canal'],
                uf: [uf],
              },
              fetchPolicy: 'no-cache',
            });
            
            commit(IMPULSIONE_VENDAS_NOTICIAS, noticias.data);
          } catch (err) {
            console.error('Erro ao buscar notícias:', err);
            errorGQLHandler(err);
            commit(SET_CARREGANDO_IMPULSIONE_VENDAS, false);
          }
        }
      }, 300);
    },
    async getAcessoVisoesCanais({ commit, state }){
      try {
        //const {data} = await env.apolloRevista.query({
        const { data } = await env.apollo.query({
          query: ACESSO_VISOES_CANAIS,
          fetchPolicy: 'no-cache',
          variables: {},
        });
        delete data.acessoVisaoCanais.__typename

        commit(ACESSO_CANAIS, data.acessoVisaoCanais);
      } catch (e) {
        console.error(e);
        errorGQLHandler(e);
      }
    },
    setCanal({ commit, state, rootGetters, dispatch }, canal) {
      commit(SET_CANAL, canal, {cache: true});      
      dispatch('getHomePageNoticias', 12) 
    },
    async getHomePageNoticiasAcessoRapido({ commit, state, rootGetters }, limit) {
      // jshint ignore:line

      const perPage = limit || state.perPage;

      commit(SET_NOTICIA_ACESSO_RAPIDO, []);

      setTimeout(async () => {
        const uf = rootGetters['user/uf'];
        if (uf) {
          try {
            const {
              data: { noticias },
            } = await env.apolloRevista.query({
              query: BUSCAR_ACESSO_RAPIDO,
              variables: {
                paginate: perPage,
                page: state.pageAcessoRapido,
                modulo: env.revista.modulo,
                uf,
                canal: rootGetters['home/canal'],
              },
              fetchPolicy: 'no-cache',
            });
            commit(SET_LAST__PAGE_NOTICIA_ACESSO_RAPIDO, noticias.last_page);
            commit(SET_NOTICIA_ACESSO_RAPIDO, noticias.data);
          } catch (e) {
            console.error(e);
            errorGQLHandler(e);
          }
        }
      });
    },
    nextPageAcessoRapido({ commit, state }) {
      if (state.pageAcessoRapido !== state.latPageAcessoRapido) {
        commit(NEXT_PAGE_NOTICIA_ACESSO_RAPIDO);
      } else {
        commit(FIRST_PAGE_NOTICIA_ACESSO_RAPIDO);
      }
    },
    prevPageAcessoRapido({ commit, state }) {
      if (state.pageAcessoRapido > 1) {
        commit(PREV_PAGE_NOTICIA_ACESSO_RAPIDO);
      } else {
        commit(LAST_PAGE_NOTICIA_ACESSO_RAPIDO);
      }
    },
  },
};
